var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('One',{staticClass:"about__block"}),_c('Two',{staticClass:"about__block"}),_c('Three',{staticClass:"about__block"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }